var map = {
	"./i18n/ar.json": [
		51783,
		"src_app_modules_features_payroll_sections_employee_payroll-category-assign_i18n_ar_json"
	],
	"./i18n/en-CA.json": [
		90996,
		"src_app_modules_features_payroll_sections_employee_payroll-category-assign_i18n_en-CA_json"
	],
	"./i18n/en-US.json": [
		66016,
		"src_app_modules_features_payroll_sections_employee_payroll-category-assign_i18n_en-US_json"
	],
	"./i18n/es-MX.json": [
		19545,
		"src_app_modules_features_payroll_sections_employee_payroll-category-assign_i18n_es-MX_json"
	],
	"./i18n/fr-CA.json": [
		31888,
		"src_app_modules_features_payroll_sections_employee_payroll-category-assign_i18n_fr-CA_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 67965;
module.exports = webpackAsyncContext;